module.exports = __webpack_public_path__ + "img/guangdong.3bc71ca1.png";